/* ==========================================================================
   Searcher > Client > Submit
   ========================================================================== */

/* Modules */
const ButtonClient = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');

const { initLoading } = require('./loading');

const configuration = require('../config');

/* get adults Room */
function getRoomAdults(rooms, index) {
    const adultsRooms = rooms
        .map(room => room.people)
        .map(cc => [...Array(cc[0].value)].fill('30%23').reduce((acc, val) => acc + val));

    return adultsRooms[index] !== undefined ? adultsRooms[index] : '';
}

/* get children Room */
function getRoomChildren(room) {
    if (!room) return '';
    const { people = [] } = room;

    if (!people[1] || !people[1].value) return '';

    const { ages = [] } = people[1];

    return ages.map(age => ''.concat(age, '%23')).join('');
}

function getAccommodationParams(instance) {
    const {
        accommodation: { rooms = [] }
    } = instance.store.select('data');

    /* Parameters Adults */
    const adultsParams = rooms
        .map(room => room.people)
        .map(cc => [...Array(cc[0].value)].fill('30%23').reduce((acc, val) => acc + val))
        .join('');

    /* Parameters Children */
    const childrenParams = rooms
        .map(room => room.people)
        .map(people => (people[1].value > 0 ? people[1].ages : []))
        .reduce((val, acc) => [...val, ...acc])
        .map(age => `${age}%23`)
        .join('');

    /* Parameters List */
    return `${adultsParams},${childrenParams}`;
}

function buildTotalPeople(instance) {
    const { accommodation = {} } = instance.store.select('data');
    const { rooms = [] } = accommodation;

    return rooms
        .map(room => {
            const { people } = room;
            return people.reduce((a, acc) => a + acc.value, 0);
        })
        .reduce((a, acc) => a + acc);
}

function buildUrl(instance) {
    /* Context */
    const { config = {} } = instance;
    const { context, urlSubmit, params = {} } = config;

    /* Data */
    const { baseUrl } = context;

    const {
        origin,
        destination,
        accommodation: { rooms = [] },
        discounts = {},
        bonus = {},
        dates,
        vehicle,
        vehicleHeight,
        vehicleLength,
        trailerHeight,
        trailerLength,
        trailer
    } = instance.store.select('data');

    /* Parameters Total People */
    const totalPeople = buildTotalPeople(instance);

    /* Prepare params config */
    if (params.application) delete params.application;
    const urlParams = Object.entries(params)
        .map(param => `&${param[0]}=${param[1]}`)
        .join('');

    /* Build url */
    return baseUrl.concat(
        `${urlSubmit}`,
        origin ? `${'?'}PuertoOrigenFER=${origin}` : '',
        destination ? `${'&'}PuertoDestinoFER=${destination}` : '',
        dates ? `${'&'}fechaIdaFER=${dates[0]}` : '',
        dates ? `${'&'}fechaVueltaFER=${dates[1]}` : '',
        totalPeople ? `${'&'}roomPax=${totalPeople}` : '',

        vehicle && vehicle.value ? `${'&'}tipoVehiculoFER=${vehicle.value}` : '',
        vehicleHeight ? `${'&'}alturaVehiculoFER=${vehicleHeight}` : '',
        vehicleLength ? `${'&'}longitudVehiculoFER=${vehicleLength}` : '',
        trailer ? `${'&'}tipoRemolqueFER=${Number(trailer)}` : '',
        trailerHeight ? `${'&'}alturaRemolqueFER=${trailerHeight}` : '',
        trailerLength ? `${'&'}longitudRemolqueFER=${trailerLength}` : '',

        discounts ? `${'&'}tipoResidenteFER=${discounts.value}` : '',
        bonus ? `${'&'}tipoDescuentoFER=${bonus.value}` : '',

        `${'&'}edad1=${getRoomAdults(rooms, 0)}${getRoomChildren(rooms[0])}`,
        `${'&'}edad2=${getRoomAdults(rooms, 1)}${getRoomChildren(rooms[1])}`,
        `${'&'}edad3=${getRoomAdults(rooms, 2)}${getRoomChildren(rooms[2])}`,
        `${'&'}edad4=${getRoomAdults(rooms, 3)}${getRoomChildren(rooms[4])}`,
        `${'&'}listaPaxEdadesFER=${getAccommodationParams(instance)}`,

        `${'&'}soloIdaFER=${0}`,
        `${'&'}numPaxFER=${totalPeople}`,
        `${urlParams}`
    );
}

/* Init submit */
function initSubmit(instance) {
    const inst = instance;
    const { config = {}, selector, subscriptions = {} } = instance;
    const { isWidget } = config;
    /* Init button */
    inst.submit = ButtonClient(`${selector} [data-component="ButtonRxjs"][data-type="${configuration().type.submit}"]`);

    if (!inst.submit) return;

    /* Extends subscriptions */
    inst.subscriptions = {
        ...subscriptions,
        submit: inst.submit.events.click$.subscribe(() => {
            /* Add Modal Loading */
            initLoading(inst);

            /* Sync store, build url */
            inst.actions.setData({ url: buildUrl(inst) });

            /* Send url */
            if (!isWidget) window.location.assign(buildUrl(inst));
        })
    };
}

/* Exports */
module.exports = {
    initSubmit,
    buildUrl
};
